import Form from 'react-bootstrap/Form';
import { FaSearch, FaTh, FaThList, FaTimes } from 'react-icons/fa';
import React, { useEffect, useRef, useState } from 'react';
import keywordimage from "../../Assets/images/keyword.png";
import locationimage from "../../Assets/images/location-pin.png";
import maintenanceimage from "../../Assets/images/maintenance.png";
import globeimage from "../../Assets/images/globe.png";
import { api_url } from '../../Constants/web_services';
import { useLocation, useNavigate } from 'react-router-dom';
import "../../Assets/css/icon-custom.css";
/* eslint-disable */
const SearchSidebar = ({ handleView, sendFormdata }) => {
  const [formData, setFormData] = useState([]);
  const [sortbytitle, setSortbytitle] = useState("");
  const location = useLocation();
  const [keyword, setKeyword] = useState("");
  const [company, setCompany] = useState("");
  const [country, setCountry] = useState("");
  const [service, setService] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [allCompany, setAllCompany] = useState('');
  const [total, setTotal] = useState('');
  const [from, setfrom] = useState('')
  const [to, setTo] = useState('');

  const [sendData, setSendData] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Automatically send the form data whenever it changes
    sendFormdata(formData);
  }, [formData, sendFormdata]);

  const handleFormdata = () => {

    setSendData(formData);
  }

  const inputRef = useRef();

  const options = {};

  useEffect(() => {
    if (window.google.maps) {
      const autoComplete = new window.google.maps.places.Autocomplete(inputRef.current, options);

      autoComplete.addListener("place_changed", () => {
        const selectedPlace = autoComplete.getPlace();
        if (selectedPlace && selectedPlace.address_components) {
          const countryComponent = selectedPlace.address_components.find(
            (component) => component.types.includes("country")
          );
          if (countryComponent) {
            const selectedCountry = countryComponent.long_name;
            setCountry(selectedCountry);
            inputRef.current.value = selectedCountry;
          }
        }
      });
    }
  }, [options]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    setKeyword(decodeURIComponent(searchParams.get("keyword") || ""));
    setCompany(decodeURIComponent(searchParams.get("company") || ""));
    setCountry(decodeURIComponent(searchParams.get("country") || ""));
    setService(decodeURIComponent(searchParams.get("service") || ""));
    setSortbytitle(decodeURIComponent(searchParams.get("sortbytitle") || ""));
    fetchData(location.search);
  }, [location.search]);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    search();
  };

  const search = () => {
    if (keyword.length >= 2) {
      fetchSuggestions(keyword)
        .then(suggestions => {
          const keywordFound = suggestions.some(suggestion =>
            suggestion.title.toLowerCase() === keyword.toLowerCase()
          );

          if (!keywordFound) {
            addKeywordToDatabase(keyword).then(() => {
              performSearch();
            });
          } else {
            performSearch();
          }
        })
        .catch(error => {
          console.error("Error during search:", error);
        });
    } else {
      performSearch();
    }
  };

  const performSearch = () => {
    const queryParams = { keyword, company, country, service, sortbytitle };
    const queryString = encodeQueryParams(queryParams);
    fetchData("?" + queryString);
  };

  const fetchData = (queryString) => {
    fetch(api_url + `/api/search${queryString}`)
      .then((response) => response.json())
      .then((data) => {
        setAllCompany(data?.data?.total_companies?.length)
        setFormData(data.data.companies);
        setTotal(data.data.companies.total)
        setfrom(data.data.companies.from)
        setTo(data.data.companies.to)
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const encodeQueryParams = (params) => {
    const encodedParams = [];
    for (const key in params) {
      if (Object.hasOwnProperty.call(params, key)) {
        const encodedKey = encodeURIComponent(key);
        const encodedValue = encodeURIComponent(params[key]);
        encodedParams.push(`${encodedKey}=${encodedValue}`);
      }
    }
    return encodedParams.join("&");
  };

  const handleInputChange = (e) => {
    const keywordValue = e.target.value;
    setKeyword(keywordValue);
    if (keywordValue.length >= 3) {
      fetchSuggestions(keywordValue);
    } else {
      setSuggestions([]);
    }
  };

  const fetchSuggestions = (keywordValue) => {
    return fetch(api_url + `/api/suggestions?keywordValue=${keywordValue}`)
      .then((response) => response.json())
      .then((data) => data.data.slice(0, 10))
      .catch((error) => {
        console.error("Error fetching suggestions:", error);
        return [];
      });
  };

  const addKeywordToDatabase = (keywordValue) => {
    return fetch(api_url + `/api/addKeyword`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ title: keywordValue })
    })
      .then(response => response.json())
      .then(data => {
        // console.log("Keyword added:", data);
      })
      .catch(error => {
        console.error("Error adding keyword:", error);
      });
  };

  const handleSuggestionClick = (suggestion) => {
    setKeyword(suggestion.title);
    setSuggestions([]);
    const queryParams = {
      keyword: suggestion.title,
      company,
      country,
      service,
    };
    navigate("/search?" + encodeQueryParams(queryParams));
  };
  const handleClearKeyword = () => {
    setKeyword("");
    setSuggestions([]);
    const queryParams = { keyword: "", company, country, service };
    navigate("/search?" + encodeQueryParams(queryParams));
  };
  const handleClearCompany = () => {
    setCompany("");
    const queryParams = { keyword, company: "", country, service };
    navigate("/search?" + encodeQueryParams(queryParams));
  };

  const handleClearCountry = () => {
    setCountry("");
    const queryParams = { keyword, company, country: "", service };
    navigate("/search?" + encodeQueryParams(queryParams));
  };

  const handleClearService = () => {
    setService("");
    const queryParams = { keyword, company, country, service: "" };
    navigate("/search?" + encodeQueryParams(queryParams));
  };
  const [remainingCompany, setRemainingCompany] = useState(0);

  useEffect(() => {
    calculateRemainingCompanies(total, allCompany);
  }, [total, allCompany]);

  const calculateRemainingCompanies = (total, allCompany) => {
    const remaining = allCompany - total;

    setRemainingCompany(remaining);
  };



  return (
    <div className="page-content sidebar--display">
      {/* Search Panel Area */}
      <div className="sf-seach-vertical sf-search-bar-panel">
        <div className="search-form ">
          <form className="clearfix search-providers " id="form--" onSubmit={handleFormSubmit}>
            <div className="sf-searchbar-box">
              <ul className="sf-searchbar-area ps-0">
                <li>
                  <div className="sf-search-title">
                    <label>Keyword</label>
                    <span className="sf-search-icon">
                      <img src={keywordimage} alt="" />
                    </span>
                  </div>
                  <div className="sf-search-feild">
                    <input
                      value={keyword}
                      onKeyUp={handleInputChange}
                      onChange={(e) => {
                        setKeyword(e.target.value);
                        const queryParams = {
                          keyword: e.target.value,
                          company,
                          country,
                          service,
                        };
                        navigate("/search?" + encodeQueryParams(queryParams));
                      }}
                      type="text"
                      placeholder="Keyword"
                      id="keyword"
                      name="keyword"
                      className="form-control sf-form-control keyword"
                    />
                    {keyword && (
                      <FaTimes
                        className="clear-input-icon keyword-icon"
                        onClick={handleClearKeyword}

                      />
                    )}
                    <ul className="suggestion-list">
                      {suggestions.map((suggestion, index) => (
                        <li
                          key={index}
                          className="suggestion-item"
                          onClick={() => handleSuggestionClick(suggestion)}
                        >
                          <h6 className="suggestion-title">
                            {suggestion.title}
                          </h6>
                        </li>
                      ))}
                    </ul>
                  </div>
                </li>
                <li>
                  <div className="sf-search-title">
                    <label>Location</label>
                    <span className="sf-search-icon">
                      <img src={locationimage} alt="" />
                    </span>
                  </div>
                  <div className="sf-search-feild">
                    <input
                      ref={inputRef}
                      value={country}
                      onChange={(e) => {
                        setCountry(e.target.value);
                        const queryParams = {
                          keyword,
                          company,
                          country: e.target.value,
                          service,
                        };
                        navigate("/search?" + encodeQueryParams(queryParams));
                      }}
                      type="text"
                      placeholder="Address"
                      id="country"
                      name="country"
                      className="form-control sf-form-control pac-target-input country"
                      autoComplete="off"
                    />
                    {country && (
                      <FaTimes
                        className="clear-input-icon country-icon"
                        onClick={handleClearCountry}

                      />
                    )}
                  </div>
                </li>
                <li>
                  <div className="sf-search-title">
                    <label>Service</label>
                    <span className="sf-search-icon">
                      <img src={maintenanceimage} alt="" />
                    </span>
                  </div>
                  <div className="sf-search-feild">
                    <input
                      type="text"
                      value={service}
                      onChange={(e) => {
                        setService(e.target.value);
                        const queryParams = {
                          keyword,
                          company,
                          country,
                          service: e.target.value,
                        };
                        navigate("/search?" + encodeQueryParams(queryParams));
                      }}
                      placeholder="service"
                      id="service"
                      name="service"
                      className="form-control sf-form-control service"
                    />
                    {service && (
                      <FaTimes
                        className="clear-input-icon service-icon"
                        onClick={handleClearService}

                      />
                    )}
                  </div>
                </li>
                <li>
                  <div className="sf-search-title">
                    <label>Company</label>
                    <span className="sf-search-icon">
                      <img src={globeimage} alt="" />
                    </span>
                  </div>
                  <div className="sf-search-feild">
                    <input
                      type="text"
                      value={company}
                      onChange={(e) => {
                        setCompany(e.target.value);
                        const queryParams = {
                          keyword,
                          company: e.target.value,
                          country,
                          service,
                        };
                        navigate("/search?" + encodeQueryParams(queryParams));
                      }}
                      placeholder="Company"
                      id="company"
                      name="company"
                      className="form-control sf-form-control company"
                    />
                    {company && (
                      <FaTimes
                        className="clear-input-icon text-022278 company-icon"
                        onClick={handleClearCompany}

                      />
                    )}
                  </div>
                </li>
              </ul>
              <button type="submit" className="site-button sf-search-btn">
                <FaSearch /> Search Now
              </button>
            </div>
          </form>
        </div>
      </div>
      <div className="aon-search-result-area mt-5">
        {/* Search Filter */}
        <div className="sf-search-result-top flex-wrap d-flex justify-content-between align-items-center mt-5">
          <div className="sf-search-result-title">

            <h5 className='text-022278 fw-bold s-18'>
              {total === 0 ? (
                <h5 className='text-022278 fw-bold s-18'>
                  No results found.
                </h5>
              ) : (
                <h5 className='text-022278 fw-bold s-18 text-center'>
                  Results based on your search :&nbsp;
                  <span className='text-dark fw-800'>{from}</span> -
                  <span className='text-dark fw-800'>{to}</span> Out of
                  <span className='text-dark fw-800'> <u>{total}</u></span>

                  <span className='text-dark fw-800'>
                    {allCompany > total && (
                      <>
                        <br />
                        <u>{remainingCompany}</u>&nbsp;
                      </>
                    )}
                  </span>
                  {allCompany > total && (
                    <>
                      more you can see
                    </>
                  )}
                </h5>
              )}
            </h5>

            {/* <h5 className='text-022278 fw-bold s-18'>Showing {rangeStart} results</h5> */}
          </div>
          <div className="sf-search-result-option d-flex justify-content-between align-items-center">
            <ul className="sf-search-sortby">
              <li className="sf-select-sort-by">
                <Form.Select
                  className="form-control"
                  title="SORT BY"
                  name="setorderby"
                  id="setorderby"
                  value={sortbytitle}
                  onChange={(e) => {
                    setSortbytitle(e.target.value);
                    const queryParams = {
                      keyword,
                      company,
                      country,
                      service,
                      sortbytitle: e.target.value,
                    };
                    navigate("/search?" + encodeQueryParams(queryParams));
                  }}
                >
                  <option>Arrange By</option>
                  <option value="asc">Name A to Z</option>
                  <option value="desc">Name Z to A</option>
                </Form.Select>
              </li>
            </ul>
            <ul className="sf-search-grid-option d-inline-flex cursor-pointer p-0 ml-3" id="viewTypes">
              <div data-view="grid-3" onChange={handleFormdata}>
                <span onClick={() => handleView('gridView', formData)} ><FaTh className='s-24'></FaTh> </span>
              </div>
              <div className="ms-2">
                <span onClick={() => handleView('listView', formData)} ><FaThList className='s-24'></FaThList> </span>
              </div>
            </ul>
          </div>
        </div>
      </div>



    </div>
  );
};

export default SearchSidebar;
